import { fetchAction } from "../../utilities";

/**
 * Template selection for Design Huddle
 */
export const designHuddleTemplateSelection = (csrfToken, cmsTemplates) =>({
    loading: true,
    apiTemplates: [],
    csrfToken: csrfToken,
    cmsTemplates: cmsTemplates,
    chooseTemplate(template) {
        this.$dispatch('dh:template-select', {template: template})
        this.$dispatch('dh:change-page', {page: 'templateForm'})
    },
    async getTemplates() {

        const templateIds = Object.values(this.cmsTemplates).map(t => t.id)

        const body = JSON.stringify({template_ids: templateIds })
        const templateActionUrl = "/actions/design-huddle/template-manager/get-design-huddle-templates"

        const response = await fetchAction(templateActionUrl, "POST", this.csrfToken, body)

        if (response.isSuccessful) {
            const responseJson =  response.successData
            const data = responseJson.data
            let unorderdApiTemplates = data.items

            console.log(unorderdApiTemplates)

            const orderedApiTemplates = templateIds.map(id => 
                unorderdApiTemplates.find(obj => obj.template_id === id)
            );
            
            this.loading = false
            this.apiTemplates = orderedApiTemplates

        } else {
            console.error("Failed to fetch templates:", response.errorData)
        }
    },
    init() {
        this.getTemplates();
    }
})